import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { AuthState } from '@/store'
import { QueryClient } from "@/services";

type MyRouterContext = {
  auth: AuthState,
  queryClient: QueryClient
}

// Esportiamo direttamente la Route
export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <Outlet />
      { process.env.NODE_ENV === 'production' ? null : <TanStackRouterDevtools position="bottom-right" initialIsOpen={false} /> }
    </>
  ),
})